import getLocal from '@/app/utils/i18n';
import { useLang } from '@/app/utils/useLang';
import { getSolarRecommand } from '@/service/solar-calculator';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoCompareProduct from 'eco-design/sections/eco-compare-product';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Modal from './components/Modal';
import Subscribe from './components/Subscribe';
import SubscribeEu from './components/SubsrcibeEu';
import styles from './index.module.scss';
import { isStatusA, isStatusB } from '../../pageStatus';

// 价格组件
const Price = ({ price, comparePrice }: { price: number; comparePrice?: number }) => {
    const { locale } = getLocal();
    return (
        <div className="price-container">
            {price && <div className="price">{FormatMoneyLocal(price, locale)}</div>}
            {comparePrice && comparePrice > price && <div className="comparePrice">{FormatMoneyLocal(comparePrice, locale)}</div>}
        </div>
    );
};

// 根据
const Explore: React.FC = () => {
    const { t } = useLang('Explore');
    const { locale = 'us' } = useRouter();
    const IS_NA = ['us', 'ca'].includes(locale);
    const [list, setList] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeProduct, setActiveProduct] = useState<any>();
    const lBtnClick = (e: React.MouseEvent<HTMLElement>, index: number | undefined) => {
        e.preventDefault();
        setIsModalOpen(true);
        setActiveProduct(items?.[index || 0]?.subItems[0]);
    };

    const specItems = (row: number) => {
        return [...new Array(locale === 'ph' ? 18 : 17)]
            .map((item, index) => {
                return {
                    desc: t(`item${row + 1}_desc${index + 1}`),
                    title: t(`item${row + 1}_title${index + 1}`),
                };
            })
            .filter((item, index) => item.title && index !== 10);
    };

    // 按区域和产品ID组织配置
    const PRODUCT_CONFIG: any = {
        us: {
            item1: { productId: '15350808346697', variantId: '54553979682889' },
            item2: { productId: '15350808346697', variantId: '54553980043337' },
            item3: { productId: '15350808346697', variantId: '54553980141641' },
        },
        ca: {
            item1: { productId: '15127284351347', variantId: '52734893490547' },
            item2: { productId: '15127284351347', variantId: '52734893523315' },
            item3: { productId: '15127284351347', variantId: '52734893556083' },
        },
        eu: {
            item1: { productId: '10248593572183', variantId: '51564168347991' },
            item2: { productId: '10248593572183', variantId: '51564168380759' },
            item3: { productId: '10248593572183', variantId: '51564168413527' },
        },
        uk: {
            item1: { productId: '10092814991699', variantId: '51728609870163' },
            item2: { productId: '10092814991699', variantId: '51728609902931' },
            item3: { productId: '10092814991699', variantId: '51728609935699' },
        },
        de: {
            item1: { productId: '15495202079101', variantId: '56791585128829' },
            item2: { productId: '15495202079101', variantId: '56791585161597' },
            item3: { productId: '15495202079101', variantId: '56791585194365' },
        },
        fr: {
            item1: { productId: '10070544580955', variantId: '51242023518555' },
            item2: { productId: '10070544580955', variantId: '51242023551323' },
            item3: { productId: '10070544580955', variantId: '51242023584091' },
        },
        it: {
            item1: { productId: '14960574136696', variantId: '55260319744376' },
            item2: { productId: '14960574136696', variantId: '55260319777144' },
            item3: { productId: '14960574136696', variantId: '55260319809912' },
        },
        es: {
            item1: { productId: '10070544679259', variantId: '51242023977307' },
            item2: { productId: '10070544679259', variantId: '51242024010075' },
            item3: { productId: '10070544679259', variantId: '51242024042843' },
        },
        nl: {
            item1: { productId: '10080514113812', variantId: '51820095340820' },
            item2: { productId: '10080514113812', variantId: '51820095373588' },
            item3: { productId: '10080514113812', variantId: '51820095406356' },
        },
        ph: {
            item1: { productId: '10304276889910', variantId: '52748141363510' },
            item2: { productId: '10304276889910', variantId: '52748141396278' },
            item3: { productId: '', variantId: '' },
        },
    };
    const getProductConfig = (itemName: any) => PRODUCT_CONFIG[locale]?.[itemName] || PRODUCT_CONFIG.us[itemName];

    let items = [
        {
            subItems: [
                {
                    title: t('item1_title'),
                    desc: t('item1_desc'),
                    lChildren: t('item1_btn'),
                    lDataLayer: {
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('item1_btn')}`,
                    },
                    productId: getProductConfig('item1').productId,
                    variantId: getProductConfig('item1').variantId,
                    specItems: specItems(0),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1757468707409/6_1%20IMG.png',
                },
            ],
        },
        {
            subItems: [
                {
                    title: t('item2_title'),
                    desc: t('item2_desc'),
                    lChildren: t('item2_btn'),
                    lDataLayer: {
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('item2_btn')}`,
                    },
                    productId: getProductConfig('item2').productId,
                    variantId: getProductConfig('item2').variantId,
                    specItems: specItems(1),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1757468707139/6_3%20IMG.png',
                },
            ],
        },
        {
            subItems: [
                {
                    title: t('item3_title'),
                    desc: t('item3_desc'),
                    lChildren: t('item3_btn'),
                    lDataLayer: {
                        event: 'uaEvent',
                        event_name: 'pop_ups',
                        title_name: t('item3_title'),
                        button_name: t('item3_btn'),
                    },
                    productId: getProductConfig('item3').productId,
                    variantId: getProductConfig('item3').variantId,
                    specItems: specItems(2),
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1757468707172/6_2%20IMG.png',
                },
            ],
        },
    ];

    const getAsynItem = async (productId: string, variantId: string) => {
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    const statusB = isStatusB();
    const statusA = isStatusA();

    useEffect(() => {
        if (!statusB) {
            const old = JSON.parse(JSON.stringify(items));

            old.forEach((item: any, idx: number) => {
                item.subItems[0].lBtnClick = lBtnClick;
                item.subItems[0].lChildren = t('item3_btn');

                if (!['us', 'ca', 'ph'].includes(locale)) {
                    old[idx].subItems[0].lDataLayer = {
                        event: 'uaEvent',
                        event_name: 'pop_ups',
                        title_name: item.subItems[0].title,
                        button_name: `${t('item3_btn')}_${item.subItems[0].title}`,
                    };
                }
            });
            setList(old);

            return;
        }
        const promises = items?.map((item: any) => getAsynItem(item?.subItems[0].productId, item.subItems[0].variantId));

        Promise.all(promises).then((res) => {
            const old = JSON.parse(JSON.stringify(items));
            const list = res.map((i: any, idx) => {
                const notSaleList = IS_NA ? [] : [2]; // 配置非开售产品 index
                const variantId = getProductConfig(`item${idx + 1}`).variantId;
                if (i.data.variantImg) {
                    old[idx].subItems[0].pc = i.data.variantImg;
                }

                if (i.data.inventoryQuantity <= 0 && i.data.inventoryPolicy === 'deny' && !notSaleList.includes(idx)) {
                    old[idx].subItems[0].lChildren = t(`item${idx + 1}_sold`);
                    old[idx].subItems[0].lDisabled = true;
                }
                if (i.data.skuTitle) {
                    old[idx].subItems[0].title = i.data.skuTitle;
                }
                // old[idx].subItems[0].lDataLayer.button_name = `${old[idx].subItems[0].lDataLayer.button_name}`;
                old[idx].subItems[0].lHref =
                    IS_NA && idx === 2
                        ? `https://${locale}.ecoflow.com/products/trail-series?variant=${variantId}&view=${locale === 'ca' ? 'trailplus300' : 'trail-plus-300'}`
                        : `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;

                old[idx].subItems[0].price = notSaleList.includes(idx) ? (
                    <div className="price-placeholder"></div>
                ) : (
                    <Price price={i.data.price} comparePrice={i.data.compareAtPrice} />
                );

                notSaleList.length > 0 && (old[`${notSaleList}`].subItems[0].lBtnClick = lBtnClick);

                if (idx === 2 && !IS_NA) {
                    old[idx].subItems[0].lDataLayer = {
                        event: 'uaEvent',
                        event_name: 'pop_ups',
                        title_name: i.data.skuTitle,
                        button_name: `${t('item3_btn')}_${i.data.skuTitle}`,
                    };
                } else {
                    old[idx].subItems[0].lDataLayer = {
                        event: 'uaEvent',
                        event_name: 'checkout',
                        button_name: `${t('item1_btn')}_${i.data.skuTitle}`,
                    };
                }

                return old[idx];
            });
            items = JSON.parse(JSON.stringify(list));
            setList(list as any);
        });
    }, []);

    const getSubscribeData = () => {
        return {
            sector_name: t('title') + '_' + activeProduct?.title,
            entry_position: 4,
        };
    };

    return (
        <div className={`${styles.Explore} GtmModuleData-section`} data-section-id="Explore">
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            {list && <EcoCompareProduct items={list}></EcoCompareProduct>}

            <Modal visible={isModalOpen} onClose={() => setIsModalOpen(false)}>
                {['us', 'ca', 'ph'].includes(locale) ? <Subscribe /> : <SubscribeEu activeProduct={activeProduct} getSubscribeData={getSubscribeData} />}
            </Modal>
        </div>
    );
};

export default Explore;
